let domain = window.location.host.replace(/^www/g, "");

if(domain.match(/localhost:/)) domain = "." + domain;

const baseUrl = `//api${domain}`;

export default baseUrl;